export {
  normalizeDraftPlayer, createGameplayDraft, isGameplayDraftV1,
  getAuthoritativeRaceCount, shouldEvaluateTieBreak, deriveScoreHistory,
  applyCharactersToRoster, isCompleteHeat, resolveLineupPlayer, resolveLineupPlayers,
} from '@mario-kart/domain';

export const GAMEPLAY_SESSION_STORAGE_KEY = 'gameplaySessionId';
const LEGACY_GAMEPLAY_STORAGE_KEYS = [
    'grandPrixData',
    'currentPlayers',
    'mapCounter',
    'scoreHistory',
    'currentGrandPrix',
];

export function clearLegacyGameplayStorage() {
    LEGACY_GAMEPLAY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
